// extracted by mini-css-extract-plugin
export default {"signatureField":"jNKCek","header":"UW580v","inputContainer":"CN1iFq"};